// Literal classes, so Tailwind can see them. Keyed by how many cards share the row.
const COLUMN_SPAN_BY_ROW_SIZE: Record<number, string> = {
  1: 'md:col-span-12',
  2: 'md:col-span-6',
  3: 'md:col-span-4',
  4: 'md:col-span-3',
};

// Rows of three on a 12-column grid; a remainder of one joins the first row, so seven cards read
// 4 + 3 rather than leaving one card alone on a third row.
export const getHighlightColumnSpans = (count: number) => {
  const rowSizes = Array.from({ length: Math.floor(count / 3) }, () => 3);
  const remainder = count % 3;
  if (remainder === 1 && rowSizes.length > 0) rowSizes[0] = 4;
  else if (remainder > 0) rowSizes.push(remainder);

  return rowSizes.flatMap((size) => Array.from({ length: size }, () => COLUMN_SPAN_BY_ROW_SIZE[size]));
};
